export { default } from './WellDone.container';
export { default as WellDone } from './WellDone';
